// extracted by mini-css-extract-plugin
module.exports = {"item":"sidebar_item__3tW8l","scroll":"sidebar_scroll__1rGYv"};